import { Navigate, useRoutes } from "react-router-dom";

import LoginPage from "../pages/login-page";
import ListClinetsPage from "../pages/list-clients";

import ProtectedRoute from "../components/protected-route";
import MarketAnalysis from "src/pages/market-analysis";
import EventMarketAnalysis from "src/pages/market-analysis/event-market-analysis";
import AccountStatementPage from "../pages/reports/account-statement";
import CurrentBetsPage from "../pages/reports/current-bets";
import GeneralReportPage from "../pages/reports/general-report";
import GameReportPage from "../pages/reports/game-report";
import CasinoReportPage from "../pages/reports/casino-report";
import DemoPage from "../pages/DemoPage";
import ProfitLossReportPage from "../pages/reports/profit-loss";
import TotalProfitLossPage from "../pages/reports/total-profit-loss";
import UserWinLossPage from "../pages/reports/user-win-loss";
import SecurityAuthPage from "../pages/security-auth";
import CasinoResultPage from "../pages/reports/casino-result";
import UserLockPage from "../pages/reports/userlock";
import UserRegisterDetailPage from "../pages/reports/userregisterdetail";
import ChangePassword from "../pages/change-password";
import ResetPasswordPage from "../pages/reset-password";
import PasswordSuccessPage from "../pages/password-success";
import AddAccount from "../pages/add-account";
import CreateAccountPage from "../pages/create-account";
import AssignAgentsPage from "../pages/assign-agents";
import UnauthorizedPage from "../pages/unauthorized";
import { LiveMarketGameEventsPage, LiveMarketPage } from "../pages/live-market";
import { CasinoAnalysisUserPage } from "../pages/casino-analysis";
import LoginAuth from "src/pages/login-auth";

export default function Router() {
  return useRoutes([
    {
      path: "/login",
      index: true,
      element: <LoginPage />,
    },
    {
      path: "/change-password",
      element: (
        <ProtectedRoute>
          <ChangePassword />
        </ProtectedRoute>
      ),
    },
    {
      path: "/reset-password",
      element: (
        <ProtectedRoute>
          <ResetPasswordPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/password-success",
      element: (
        <ProtectedRoute>
          <PasswordSuccessPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/list-clients/:userId",
      element: (
        <ProtectedRoute permission="user_list">
          <ListClinetsPage users_type={"all"} />
        </ProtectedRoute>
      ),
    },
    {
      path: "/add-account",
      element: (
        <ProtectedRoute permission="insert_user">
          <AddAccount />
        </ProtectedRoute>
      ),
    },
    {
      path: "/createaccount",
      element: (
        <ProtectedRoute permission="login_user_creation">
          <CreateAccountPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/active-users/:userId",
      element: (
        <ProtectedRoute permission="user_list">
          <ListClinetsPage users_type={"both"} />
        </ProtectedRoute>
      ),
    },
    {
      path: "/assign-agents",
      element: (
        <ProtectedRoute permission="agent_assign">
          <AssignAgentsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/account-statement",
      element: (
        <ProtectedRoute permission="account_statement">
          <AccountStatementPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/current-bets",
      element: (
        <ProtectedRoute permission="current_bets">
          <CurrentBetsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/general-report",
      element: (
        <ProtectedRoute>
          <GeneralReportPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/game-report",
      element: (
        <ProtectedRoute>
          <GameReportPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/casino-report",
      element: (
        <ProtectedRoute permission="live_casino_result">
          <CasinoReportPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/profit-loss",
      element: (
        <ProtectedRoute permission="party_win_loss">
          <ProfitLossReportPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/2fa-auth/:name",
      element: <LoginAuth />,
    },
    {
      path: "/security-auth",
      element: (
        <ProtectedRoute>
          <SecurityAuthPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/casinoresult",
      element: (
        <ProtectedRoute permission="casino_result">
          <CasinoResultPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/userlock",
      element: (
        <ProtectedRoute permission="general_lock">
          <UserLockPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/userregisterdetail",
      element: (
        <ProtectedRoute permission="user_register_report">
          <UserRegisterDetailPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/totalprofitloss",
      element: (
        <ProtectedRoute permission="total_profitloss">
          <TotalProfitLossPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/userwinloss",
      element: (
        <ProtectedRoute permission="user_winloss">
          <UserWinLossPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/403",
      element: (
        <ProtectedRoute>
          <UnauthorizedPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/unauthorized",
      element: (
        <ProtectedRoute>
          <UnauthorizedPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/market-analysis",
      element: (
        <ProtectedRoute>
          <MarketAnalysis />
        </ProtectedRoute>
      ),
    },
    {
      path: "/game/details/:providerId/:eventId/:marketId?",
      element: (
        <ProtectedRoute>
          <EventMarketAnalysis />
        </ProtectedRoute>
      ),
    },
    {
      path: "/live-market/:casinoType",
      element: (
        <ProtectedRoute permission="our_casino">
          <LiveMarketPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/live-market/:casinoType/game/:gameId",
      element: (
        <ProtectedRoute permission="our_casino">
          <LiveMarketGameEventsPage />
        </ProtectedRoute>
      ),
    },
    {
      path: "/casinoanalysisuser/:providerEventId",
      element: (
        <ProtectedRoute permission="our_casino">
          <CasinoAnalysisUserPage />
        </ProtectedRoute>
      ),
    },

    {
      path: "/bs",
      element: <DemoPage />,
    },
    {
      path: "/",
      element: <Navigate to="/login" replace />,
    },
    {
      path: "*",
      element: <Navigate to="/login" replace />,
    },
  ]);
}
